import { Component } from '@verndale/core';

class HorizontalTopNavigationRow extends Component {
  setupDefaults() {
    this.dom = {
      toggleBtn: this.el.querySelector('.horizontal-top-navigation-row__toggle') as HTMLElement,
      navList: this.el.querySelector('.horizontal-top-navigation-row__nav-links') as HTMLElement,
    };
  }

  addListeners() {
    (this.dom.toggleBtn as HTMLElement).addEventListener('click', this.handleToggle.bind(this));
  }

  handleToggle() {
    const toggleBtn = (this.dom.toggleBtn as HTMLElement);
    const isExpanded = (this.dom.navList as HTMLElement).classList.contains('active');
    const navList = (this.dom.navList as HTMLElement);

    navList.classList.toggle('active', !isExpanded);
    toggleBtn.setAttribute('aria-expanded', (!isExpanded).toString());
    navList.setAttribute('aria-hidden', isExpanded.toString());

  }
}

export default HorizontalTopNavigationRow;
